import type { NoteBlock } from "@vita-learning/types";

export const initializePlateValue = (content?: NoteBlock[]): NoteBlock[] => {
	if (!content || !content.length)
		return [
			{
				type: "p",
				children: [{ text: "" }],
			},
		];

	return content;
};
